import { render, staticRenderFns } from "./paySummaryDetail.vue?vue&type=template&id=fca88e7c&scoped=true&"
import script from "./paySummaryDetail.vue?vue&type=script&lang=js&"
export * from "./paySummaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./paySummaryDetail.vue?vue&type=style&index=0&id=fca88e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca88e7c",
  null
  
)

export default component.exports